import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    assignPaypalBatchFileToOrder,
    getPaypalBatches,
    getPaypalBatchFileDetails,
    getPaypalUnassignedOrders,
} from 'src/api/paypal-batch';
import { enqueueSnackbarAction } from '../notifications/actions';
import {
    ASSIGN_BATCH_FILE_TO_ORDER,
    FETCH_PAYPAL_BATCHES,
    FETCH_PAYPAL_BATCH_FILE_DETAILS,
    FETCH_PAYPAL_UNASSIGNED_ORDERS,
    requestAssignBatchFileToOrder,
    requestAssignBatchFileToOrderFailure,
    requestAssignBatchFileToOrderSuccess,
    requestPaypalBatches,
    requestPaypalBatchesFailure,
    requestPaypalBatchesSuccess,
    requestPaypalBatchFileDetails,
    requestPaypalBatchFileDetailsFailure,
    requestPaypalBatchFileDetailsSuccess,
    requestPaypalUnassignedOrders,
    requestPaypalUnassignedOrdersFailure,
    requestPaypalUnassignedOrdersSuccess,
} from './actions';

function* fetchPaypalBatchesSaga(action: AnyAction): SagaIterator {
    yield put(requestPaypalBatches());

    const { error, response } = yield call(getPaypalBatches, action.pageable);

    if (error) {
        yield put(requestPaypalBatchesFailure(error));
    } else {
        yield put(requestPaypalBatchesSuccess(response));
    }
}

export function* generateFetchPaypalBatchesWatcher() {
    yield takeLatest(FETCH_PAYPAL_BATCHES, fetchPaypalBatchesSaga);
}

function* fetchPayPalBatchFileDetailsSaga(action: AnyAction): SagaIterator {
    yield put(requestPaypalBatchFileDetails());

    const { error, response } = yield call(getPaypalBatchFileDetails, action.paypalBatchFileId);

    if (error) {
        yield put(requestPaypalBatchFileDetailsFailure(error));
    } else {
        yield put(requestPaypalBatchFileDetailsSuccess(response));
    }
}

export function* generateFetchPaypalBatchFileDetailsWatcher() {
    yield takeLatest(FETCH_PAYPAL_BATCH_FILE_DETAILS, fetchPayPalBatchFileDetailsSaga);
}

function* fetchPaypalUnassignedOrdersSaga(action: AnyAction): SagaIterator {
    yield put(requestPaypalUnassignedOrders());

    const { error, response } = yield call(getPaypalUnassignedOrders, action.paypalBatchFileDetailId);

    if (error) {
        yield put(requestPaypalUnassignedOrdersFailure(error));
    } else {
        yield put(requestPaypalUnassignedOrdersSuccess(response));
    }
}

export function* generateFetchPaypalUnassignedOrdersWatcher() {
    yield takeLatest(FETCH_PAYPAL_UNASSIGNED_ORDERS, fetchPaypalUnassignedOrdersSaga);
}

function* assignBatchFileToOrderSaga(action: AnyAction): SagaIterator {
    yield put(requestAssignBatchFileToOrder());

    const { error, response } = yield call(
        assignPaypalBatchFileToOrder,
        action.paypalBatchFileDetailId,
        action.orderId
    );

    if (error) {
        yield put(requestAssignBatchFileToOrderFailure(error));
        yield put(
            enqueueSnackbarAction({
                message: error.message,
                options: { key: new Date().getTime() + Math.random(), variant: 'error' },
            })
        );
    } else {
        yield put(requestAssignBatchFileToOrderSuccess(response));
        yield put(
            enqueueSnackbarAction({
                message: 'Success',
                options: { key: new Date().getTime() + Math.random(), variant: 'success' },
            })
        );
    }
}

export function* generateAssignBatchFileToOrderWatcher() {
    yield takeLatest(ASSIGN_BATCH_FILE_TO_ORDER, assignBatchFileToOrderSaga);
}
